export {
  getUserPermissionsPromise,
  getSettings,
  getInstallerShowPromise,
  getPageTypePromise
} from './roleCtrl';